import { coreInitiativesFilesAddSyncSlice } from './add';
import { CoreInitiativesFilesName } from './name';
import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postInitiativeFile } from '@api';

export const coreInitiativesFilesPostAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [ coreInitiativesFilesAddSyncSlice.syncActionCreator ]
	},
	name: CoreInitiativesFilesName,
	receive: true,
	request: true,
	requestHandler: postInitiativeFile
});
